import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import EmergencyButton from "@/components/EmergencyButton";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import UeberUns from "@/pages/UeberUns";
import Schreinerei from "@/pages/Schreinerei";
import Bestattungen from "@/pages/Bestattungen";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import "@/App.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <AnimatePresence>{loading && <Loader key="loader" />}</AnimatePresence>
      {!loading && (
        <BrowserRouter>
          <div className="min-h-screen bg-[#F8F5F0]">
            <Navbar />
            <EmergencyButton />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/ueber-uns" element={<UeberUns />} />
              <Route path="/schreinerei" element={<Schreinerei />} />
              <Route path="/bestattungen" element={<Bestattungen />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
